export default function (target, className) {
  while (target.parentNode && (` ${target.parentNode.className} `).indexOf(` ${className} `) === -1) {
    target = target.parentNode;
  }

  return target.nodeName !== '#document'
}
